import styled from "styled-components";

import { CHART_CONFIG } from "./carbonEmissionsGraph.config";

export const GraphContainer = styled.div`
  width: 100%;
  height: ${CHART_CONFIG.dimensions.height}px;
  margin-top: 24px;
  position: relative;
  overflow: visible;
`;

export const Tooltip = styled.div<{ showOnLeft?: boolean }>`
  position: absolute;
  padding: 8px;
  background: var(--mode-bg-neutral-weakest);
  border: 1px solid var(--mode-border-neutral-default);
  border-radius: 2px;
  pointer-events: none;
  font-size: 13px;
  font-weight: 400;
  box-shadow: 0 6px 24px 0 rgba(152, 160, 171, 0.4);
  transform: ${props =>
    props.showOnLeft ? "translateX(-100%)" : "translateX(-50%)"};
  margin-left: ${props =>
    props.showOnLeft
      ? "-10px"
      : "0"}; // Add a small offset when showing on the left
  margin-top: 8px;
  white-space: nowrap;
  z-index: 1000;
`;

export const TooltipValue = styled.span`
  font-weight: 600;
`;
